import React, { Component } from "react";
import "./styles.css";
import E from "../../../js/events";
import D from "../../../js/debounce.js";
import M from "moment";  // Moment - https://momentjs.com/
// import S from "swiper";  // Doesn't compile with Webpack!?
import S from "swiper/dist/js/swiper.js";  // Swiper - http://idangero.us/swiper/

import FloatingHeader  from "../../widgets/floating-header/view";
import FloatingFooter  from "../../widgets/floating-footer/view";
import FloatingSidebar from "../../widgets/floating-sidebar/view";

import SectionEventType    from "../../sections/eventtype/view";
import SectionIntro    from "../../sections/intro/view";
import SectionLocation from "../../sections/location/view";
import SectionDatetime from "../../sections/datetime/view";
import SectionPackage  from "../../sections/package/view";
import SectionCake     from "../../sections/cake/view";
import SectionSummary  from "../../sections/summary/view";





class ScreenCarousel extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.refreshScreen            = this.refreshScreen.bind(this);
    this.onSlideChange            = this.onSlideChange.bind(this);
    this.handleSlideChangeRequest = this.handleSlideChangeRequest.bind(this);

    this.state = {
      isInit: false,
    };
  }



  // ===============================================================================================
  // Recalculates screen heights
  refreshScreen() {
    if (this.carousel) {
      let wrapper = (this.carousel).el.querySelector(".swiper-wrapper");
      let slides  = (this.carousel).slides;

      // Get slide heights
      let heights = [];
      let curHeight = 0;

      for (let i = 0; i < slides.length; i++) {
        slides[i].style.minHeight = ``;
        let sect = slides[i].querySelector(".cont-section");
        heights.push(sect.scrollHeight);

        if (slides[i].classList.contains("swiper-slide-active")) {
          curHeight = sect.scrollHeight;
        }
      };

      let sidebar = (this.carousel).el.querySelector(".floating-sidebar");
      heights.push(sidebar.scrollHeight);
      // console.log('slide heights:');
      // console.log(heights);
      // Get minimum height
      heights.sort((a, b) => { return b - a; });
      let minHeight = heights[1];

      if (wrapper.offsetWidth > 768) {
        // On desktop layout, just use the second largest
        if (minHeight < 900) {
          minHeight = 900;
        } 
        minHeight = minHeight + "px";
        curHeight = curHeight + "px";
        // Assign current height to the wrapper (only for desktop)
        wrapper.style.height = `${curHeight}`;
      }
      else {
        minHeight = "auto";
      }


      // Assign minimum height to all of our slides
      for (let i = 0; i < slides.length; i++) {
        slides[i].style.minHeight = `${minHeight}`;
      };

      (this.carousel).update();
    }
  }



  // ===============================================================================================
  // Triggered when the current slide changes
  onSlideChange(newActiveIndex) {
    // console.log(`New active slide ${newActiveIndex} (${this.props.items[newActiveIndex].id})`);

    let slide   =  this.props.items[newActiveIndex];
    let visited = (this.props.app_visitedSlides.indexOf(newActiveIndex) >= 0) ? true : false;

    // Update state with the new active index
    this.props.handleSlideChange(this.carousel.activeIndex);



    setTimeout(() => {
      if (slide && visited !== true) {
        switch(slide.id) {

          case "intro":
            let newChild = { name: "", age: "" };
            this.props.handleAppEvent(E.events.INTRO_ADD_CHILD, newChild);
            break;

          case "location":
            break;

          case "package":
            break;

          case "datetime":
            break;

          case "cake":
            // this.props.handleAppEvent(E.events.CAKE_MOD_CAKE, 2);
            break;

          case "summary":
            break;

          default:
            // No default action

        }
      }
    }, 1);
  }



  // ===============================================================================================
  // Changes to the selected slide
  handleSlideChangeRequest(selectedIndex) {
    // console.log(`Moving to slide: ${selectedIndex}`);
    if (typeof selectedIndex === 'number') {
      this.carousel.slideTo(selectedIndex);
      return;
    } else if (typeof selectedIndex === 'string') {
        const parsedIndex = parseInt(selectedIndex, 10);
        if (!isNaN(parsedIndex)) {
            selectedIndex = parsedIndex;
            this.carousel.slideTo(selectedIndex);
            return;
        } else {
          const matchingIndex = this.props.items.findIndex(item => item.id === selectedIndex);
          if (matchingIndex !== -1) {
              selectedIndex = matchingIndex;
              this.carousel.slideTo(selectedIndex);
              return;
          } else {
              console.error(`No slide found with id: "${selectedIndex}"`);
              return;
          }
        }
    }
    console.error(`selectedIndex must be an integer, a string representing an integer or a string representing a slide id. Received type "${typeof selectedIndex}"`);
  }



  // ===============================================================================================
  // On startup
  componentDidMount() {
    let initialSlide = (this.props.app_activeSlide !== null) ? this.props.app_activeSlide : 0;

    // Using Swiper: http://idangero.us/swiper/api/
    this.carousel = new S(this.carouselEle, {
      initialSlide:   initialSlide,
      simulateTouch:  false,  // Disable with mouse (desktop)
      speed:          500,
      roundLengths:   true,
      autoHeight:     true,
      // allowTouchMove: false,
    });



    // Update current activeIndex on slide change (and therefore the background colour)
    this.onSlideChange(initialSlide);
    this.carousel.on("slideChange", () => {
      this.onSlideChange(this.carousel.activeIndex);
    });



    // Update minimum height of slides
    this.refreshScreen();
    setTimeout(() => { this.refreshScreen(); }, 500);
    window.addEventListener("resize", D(this.refreshScreen, 500));

    // Make the screen visible
    setTimeout(() => {
      this.setState({ isInit: true });
    }, 1);
  }



  // ===============================================================================================
  render() {

    // let eventType = this.props.eventType;

    // ---------------------------------------------------------------------------------------------
    // Get current slide name (controls background colour in CSS)
    let slideName = null;
    if (this.props.items && this.props.items[this.props.app_activeSlide]) {
      slideName = this.props.items[this.props.app_activeSlide].id;
    }
    // console.log("PROPS:", this.props);
    // console.log("SLIDE NAME:", slideName);



    // ---------------------------------------------------------------------------------------------
    // Detect errors for IntroSection
    let viewIntroSection = {
      stars: this.props.intro_starList,
      total: this.props.intro_starList.length,
    };



    if (viewIntroSection) {
      (viewIntroSection.stars).forEach((item) => {
        if (this.props.eventType === 'hosted') {
          if (item.name === "" || item.age === "") {
            viewIntroSection.error = {
            label: "Please review the birthday children's details",
            };
          }
        } else if (this.props.eventType === 'no-host') {
          if (item.name === "") {
            viewIntroSection.error = {
            label: "Please review the name details",
            };
          }
        }
      });
    }



    // ---------------------------------------------------------------------------------------------
    // Detect errors for PackageSection
    let viewPackageSection = {
      // isPremium: this.props.package_isPremium,
      adults:    this.props.package_numAdults,
      stars:     this.props.intro_starList.length,
      kids:      this.props.package_numChilds,
      minCapacity: this.props.location_selLocation ? this.props.location_selLocation.min_capacity : 1,
      total:     this.props.intro_starList.length +
                 this.props.package_numChilds,
    };


    if (viewPackageSection.total < viewPackageSection.minCapacity) {
      viewPackageSection.total = viewPackageSection.minCapacity;
    }

    if (viewPackageSection) {
      if (viewPackageSection.total > 0) {
        let num = viewPackageSection.total + "× ";

        let label = {
          'hosted': num + "Children",
          'no-host': num + "Persons",
        };
        // if (viewPackageSection.isPremium) {
        //   viewPackageSection.summary = {
        //     label: num + "Premium Party Package",
        //   };
        // }
        // else {
          viewPackageSection.summary = {
            label: label[this.props.eventType],
          // };
        }
      } else {
        viewPackageSection.error = {
          label: "Please check the number of children",
        }
      }

      // Also get star children error (for missing details)
      // if (viewIntroSection.error) {
      //   viewPackageSection.error = viewPackageSection.error
      // }
    }



    // ---------------------------------------------------------------------------------------------
    // Detect errors for LocationSection
    let viewLocationSection = {
      location: this.props.location_selLocation,
    };



    if (viewLocationSection) {
      if (viewLocationSection.location) {
        viewLocationSection.summary = {
          label:    (viewLocationSection.location).name,
          // sublabel: (viewLocationSection.location).address,
        };

        // if (viewPackageSection.total < (viewLocationSection.location).min_capacity) {
        //   viewLocationSection.error = {
        //     label: "This restaurant has a minimum room capacity of " +
        //            (viewLocationSection.location).min_capacity + ".",
        //   };
        // }
        // else if (viewPackageSection.total > (viewLocationSection.location).max_capacity) {
        //   viewLocationSection.error = {
        //     label: "This restaurant has a maximum room capacity of " +
        //            (viewLocationSection.location).max_capacity +
        //            " (you're bringing along " + viewPackageSection.total + ").",
        //   };
        // }
      }
      else {
        viewLocationSection.error = {
          label: "Please select a restaurant",
        };
      }

    }



    // ---------------------------------------------------------------------------------------------
    // Detect errors for DatetimeSection
    let viewDatetimeSection = {
      date: this.props.datetime_selDate,
      time: this.props.datetime_selTime,
    };



    if (viewDatetimeSection) {
      if (M.isMoment(viewDatetimeSection.date) && viewDatetimeSection.time) {
        let dateStr = (viewDatetimeSection.date).format("dddd, D MMMM YYYY");
        if (M().year() === (viewDatetimeSection.date).year()) {
          dateStr   = (viewDatetimeSection.date).format("dddd, D MMMM");
        }
        let timeStr = (viewDatetimeSection.time.label !== "") ? " - " + viewDatetimeSection.time.label : ""
        viewDatetimeSection.summary = {
          label:    `${dateStr} ${timeStr}`,
          // sublabel: `${viewDatetimeSection.time.label}`,
        };
      }
      else if (M.isMoment(viewDatetimeSection.date)) {
        let dateStr = (viewDatetimeSection.date).format("dddd, D MMMM YYYY");
        if (M().year() === (viewDatetimeSection.date).year()) {
          dateStr   = (viewDatetimeSection.date).format("dddd, D MMMM");
        }
        viewDatetimeSection.summary = {
          label: `${dateStr}`,
        };
        viewDatetimeSection.error = {
          label: "Please select a time",
        };
      }
      else {
        viewDatetimeSection.error = {
          label: "Please select a date & time",
        };
      }
    }



    // ---------------------------------------------------------------------------------------------
    // Detect errors for CakeSection
    let viewCakeSection = {
      cakes: this.props.cake_numCakes,
      isByo: this.props.cake_isByo,
      optionalInclusionsNoHost: this.props.cake_numOptionalInclusionsNoHost,
    };



    if (viewCakeSection) {
      var labelStr = "Bringing your own cake";
      var subLabelStr = "";
      if(viewCakeSection.isByo) {
        if(viewCakeSection.cakes > 0) {
          subLabelStr = labelStr;
          labelStr = viewCakeSection.cakes + "× Ice Cream Cake";
        } else if(viewCakeSection.cakes === 0){
          labelStr = "Bringing your own cake only";
        }
      } else {
        if(viewCakeSection.cakes > 0) {
          labelStr = viewCakeSection.cakes + "× Ice Cream Cake";
        } else if(viewCakeSection.cakes === 0){
          labelStr = "No cakes for your party"
        }
      }
      viewCakeSection.summary = {
        label: labelStr,
        sublabel: subLabelStr,
      };
    }



    // ---------------------------------------------------------------------------------------------
    // Detect errors for SummarySection
    let viewSummarySection = {
      first_name: this.props.summary_firstName,
      last_name: this.props.summary_lastName,
      email: this.props.summary_email,
      phone: this.props.summary_phone,
      reqs:  this.props.summary_reqs,
      tAndC:  this.props.summary_tAndC,
      privacy: this.props.summary_privacy,
    };



    if (viewSummarySection) {
      viewSummarySection.summary = {
        label: "Summary",
      };
    }



    // ---------------------------------------------------------------------------------------------
    return (
      <div className={"carousel" +
          ((this.state.isInit) ? " carousel--visible"      : "") +
          ((slideName)         ? " carousel--" + slideName : "")}
          ref={(ele) => { this.screenEle = ele; }}>

        <div className="swiper-container"
          ref={(ele) => { this.carouselEle = ele; }}>

          <div className="swiper-container-scroll-anchor"></div>



          <div className="swiper-wrapper">

            <div className="swiper-slide">
              <SectionEventType
                eventType={      this.props.eventType          }
                items={          this.props.items              }
                activeSlide={    this.props.app_activeSlide    }
                activeSlideId={  this.props.app_activeSlideId  }
                handleAppEvent={ this.props.handleAppEvent     }
                handleChange={   this.handleSlideChangeRequest }
                handleAppPopup={ this.props.handleAppPopup     }
              />
            </div>

            <div className="swiper-slide">
              <SectionIntro
                eventType={      this.props.eventType      }
                items={          this.props.items              }
                activeSlide={    this.props.app_activeSlide    }
                activeSlideId={  this.props.app_activeSlideId  }
                starList={       this.props.intro_starList     }
                handleAppEvent={ this.props.handleAppEvent     }
                handleChange={   this.handleSlideChangeRequest }
              />
            </div>



            <div className="swiper-slide">
              <SectionLocation
                eventType={      this.props.eventType               }
                query={          this.props.location_query          }
                locations={      this.props.app_cache_locations     }
                selLocation={    this.props.location_selLocation    }
                numAttending={   this.props.intro_starList.length +
                                 this.props.package_numChilds       }
                handleAppEvent={ this.props.handleAppEvent          }
                handleChange={   this.handleSlideChangeRequest      }
                products={       this.props.app_cache_products      }
              />
            </div>



            <div className="swiper-slide">
              <SectionPackage
                eventType={      this.props.eventType             }
                selLocation={    this.props.location_selLocation  }
                // infoStandard={   this.props.app_info_standard     }
                // infoPremium={    this.props.app_info_premium      }
                // infoNoHost={     this.props.app_info_noHost       }
                minChildren={    this.props.intro_starList.length }
                numChildren={    this.props.package_numChilds     }
                numAdults={      this.props.package_numAdults     }
                // isPremium={      this.props.package_isPremium     }
                handleAppEvent={ this.props.handleAppEvent        }
                products={       this.props.app_cache_products    }
              />
            </div>


            <div className="swiper-slide">
              <SectionDatetime
                eventType={      this.props.eventType               }
                editState={      this.props.app_editState           }
                selDate={        this.props.datetime_selDate        }
                selTime={        this.props.datetime_selTime        }
                selLocation={    this.props.location_selLocation    }
                numAttending={   this.props.intro_starList.length +
                                 this.props.package_numChilds       }
                handleAppEvent={ this.props.handleAppEvent          }
                handleAppPopup={ this.props.handleAppPopup          }
              />
            </div>



            <div className="swiper-slide">
              <SectionCake
                eventType={      this.props.eventType             }
                selLocation={    this.props.location_selLocation  }
                // infoByo={        this.props.app_info_byoCake      }
                numCakes={       this.props.cake_numCakes         }
                isByo={          this.props.cake_isByo            }
                numOptionalInclusionsNoHost={this.props.cake_numOptionalInclusionsNoHost}
                handleAppEvent={ this.props.handleAppEvent        }
                products={       this.props.app_cache_products    }
              />
            </div>



            <div className="swiper-slide">
              <SectionSummary
                eventType={                this.props.eventType          }
                items={                    this.props.items              }
                cake={                     this.props.app_cake           }
                price={                    this.props.app_totalPrice     }
                loginState={               this.props.app_loginState     }
                editState={                this.props.app_editState      }
                activeSlide={              this.props.app_activeSlide    }
                activeSlideId={            this.props.app_activeSlideId  }
                visitedSlides={            this.props.app_visitedSlides  }
                sIntro={                   viewIntroSection              }
                sLocation={                viewLocationSection           }
                sPackage={                 viewPackageSection            }
                sDatetime={                viewDatetimeSection           }
                sCake={                    viewCakeSection               }
                sSummary={                 viewSummarySection            }
                handleSlideChangeRequest={ this.handleSlideChangeRequest }
                handleAppEvent={           this.props.handleAppEvent     }
                handleAppPopup={           this.props.handleAppPopup     }
              />
            </div>

          </div>



          <FloatingSidebar
            eventType={      this.props.eventType                            }
            items={         this.props.items                                 }
            // loginState={    this.props.app_loginState     }
            // editState={     this.props.app_editState       }
            price={         this.props.app_totalPrice                        }
            hidden={       (this.props.app_activeSlideId === 'intro' || this.props.app_activeSlideId === 'eventType') ? true : false }
            activeSlide={   this.props.app_activeSlide                       }
            activeSlideId={ this.props.app_activeSlideId                     }
            visitedSlides={ this.props.app_visitedSlides                     }
            sIntro={        viewIntroSection                                 }
            sLocation={     viewLocationSection                              }
            sPackage={      viewPackageSection                               }
            sDatetime={     viewDatetimeSection                              }
            sCake={         viewCakeSection                                  }
            sSummary={      viewSummarySection                               }
            handleChange={  this.handleSlideChangeRequest                    }
          />



          <FloatingHeader
            items={        this.props.items                                 }
            hidden={      (this.props.app_activeSlideId === 'intro' || this.props.app_activeSlideId === 'eventType') ? true : false }
            activeSlide={  this.props.app_activeSlide                       }
            activeSlideId={ this.props.app_activeSlideId                    }
            handleChange={ this.handleSlideChangeRequest                    }
          />



          <FloatingFooter
            eventType={    this.props.eventType                                                       }
            items={        this.props.items                                                           }
            sIntro={       viewIntroSection                                                           }
            sPackage={     viewPackageSection                                                         }
            price={        this.props.app_totalPrice                                                  }
            hidden={      (this.props.app_activeSlideId === 'intro' || this.props.app_activeSlideId === 'eventType') ? true : false }
            activeSlide={  this.props.app_activeSlide                                                 }
            activeSlideId={ this.props.app_activeSlideId                                              }
            handleChange={ this.handleSlideChangeRequest                                              }
          />


        </div>

      </div>
    );
  }

}



export default ScreenCarousel;
